module.exports = __webpack_public_path__ + "images/places/training_669-bbc02c050b81c2846b49455cac4e9a21.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_669.jpg
 ** module id = 322
 ** module chunks = 0
 **/